<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    resource="customerservices"
    status-module="saasTechSupport" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SaasTechSupportDetail',
  mixins: [WindowsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        {
          field: 'type',
          title: this.$t('common_56'),
          formatter: ({ cellValue }) => {
            return cellValue === 'consulting' ? this.$t('scope.technical_consulting') : this.$t('scope.remote_assistance')
          },
        },
      ],
    }
  },
  async created () {
  },
  methods: {
  },
}
</script>
